<!-- Пустое состояние титула с текстами, переданными доменным слоем. -->
<template>
  <div class="edo-title-empty-state">
    <BaseEmptyState
      :title="title"
      :description="description"
      icon="documentOutline"
    />

    <div v-if="fields.length" class="edo-title-empty-state__fields">
      <span
        v-for="field in fields"
        :key="field"
        class="edo-title-empty-state__field"
      >
        {{ field }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "EdoDocumentTitleEmptyState",

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.edo-title-empty-state {
  display: grid;
  justify-items: center;
  gap: 14px;
  margin: 22px 24px 24px;
  padding: 28px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: #fafbfd;
}

.edo-title-empty-state :deep(.empty-state) {
  max-width: 620px;
  border: 0;
  background: transparent;
}

.edo-title-empty-state__fields {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.edo-title-empty-state__field {
  padding: 5px 10px;
  border-radius: 999px;
  background: #f3f5f9;
  color: #3d4152;
  font-size: 13px;
  line-height: 18px;
}

@media (max-width: 720px) {
  .edo-title-empty-state {
    margin: 18px 14px 20px;
    padding: 18px 14px;
  }
}
</style>
